var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.src)?_c('img',{attrs:{"src":_vm.src,"alt":_vm.alt,"loading":_vm.eager ? 'eager' : 'lazy',"fetchpriority":_vm.eager || _vm.preload ? 'high' : 'auto',"decoding":"async"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }